import {useFourthStep} from "./useFourthStep";
import s from "./fourthStep.module.css";
import RadioInput from "./RadioInput";
import AdditionalComment from "./AdditionalComment";
import {fourthStepBackground, thirdStepBackground} from "../../../../assets";
import {useAppContext} from "../../../../contexts";

const FourthStep = (props) => {
    // Destructured props
    const {
        handleStepChange,
        handlePayloadUpdate,
        surveyData,
        currentStep
    } = props;

    // Component logic data
    const componentProps = useFourthStep({
        handleStepChange,
        handlePayloadUpdate,
        surveyData
    });

    // Destructured component logic data
    const {
        formValues,
        shouldDisableOptions,
        handleChange,
        handleSubmit
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // The variable name already says it all
    const availableOptions = surveyData.options.map(option => {
        return (
            <RadioInput
                key={option.id}
                value={option.id}
                label={option.label}
                formValues={formValues}
                handleChange={handleChange}
                shouldDisableOptions={shouldDisableOptions}
            />
        )
    }) || null;

    return (
        <div className={`${s.root} ${currentStep !== 4 ? s.hideContent : ""}`}>
            <div className={`w-full flex flex-col md:flex-row items-start justify-between gap-y-12 gap-x-24`}>
                <div className={"w-full"}>
                    <h1 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                        Como você ficou sabendo da Loja Virtual do Sabin?
                    </h1>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className={"my-8 w-full flex flex-col items-start justify-between gap-y-3.5"}>
                            {availableOptions}
                        </div>
                        <AdditionalComment
                            formValues={formValues}
                            handleChange={handleChange}
                        />
                    </form>
                </div>
                <div className={"flex flex-row justify-center w-full md:w-max shrink-0"}>
                    <img
                        src={fourthStepBackground}
                        alt="Background image"
                    />
                </div>
            </div>
        </div>
    )
}

export default FourthStep;
